import { render, staticRenderFns } from "./templatetUpload.vue?vue&type=template&id=6e68b41a&scoped=true&"
import script from "./templatetUpload.vue?vue&type=script&lang=js&"
export * from "./templatetUpload.vue?vue&type=script&lang=js&"
import style0 from "./templatetUpload.vue?vue&type=style&index=0&id=6e68b41a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e68b41a",
  null
  
)

export default component.exports